import { globalAdminUrl } from './globalApi';

export const CommonApiforJourney = async (method, endpoint, credentials, authToken, formType) => {
  try {
    const headerData = {};
    const requestBody = {};
    if (formType === 'formdata') {
      headerData.Authorization = `Bearer ${authToken}`;
    } else {
      headerData['Content-Type'] = `application/json`;
      headerData.Authorization = `Bearer ${authToken}`;
    }

    if (method === 'GET') {
      requestBody.method = method;
      requestBody.headers = headerData;
    } else {
      requestBody.method = method;
      requestBody.headers = headerData;
      requestBody.body = credentials;
    }

    return await fetch(`${globalAdminUrl}/${endpoint}`, requestBody)
      .then((response) => response.json())
      .then((res) => res);
  } catch (error) {
    return {
      msg: `Server not responding error ${error}`
    };
  }
};
